export default __webpack_public_path__ + "static/media/Guru-Parampara-20.34b2c260.png";